var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-autocomplete", {
        attrs: {
          "hide-details": "",
          dense: "",
          outlined: "",
          items: _vm.regions,
          outlined: "",
          autocomplete: "",
        },
        model: {
          value: _vm.viewValue,
          callback: function ($$v) {
            _vm.viewValue = $$v
          },
          expression: "viewValue",
        },
      }),
      _vm._v(" "),
      _c("h5", [_vm._v(_vm._s(_vm.country))]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: _vm.field.fieldName },
        domProps: { value: _vm.field.value },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }